import React from 'react';
import { Button, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

import { useContractState } from 'pricing/components/contract/useContractState/useContractState';
import { testId } from 'pricing/utilities/test/dataTestId';

function UploadContractAmendment() {
  const { dispatch } = useContractState();
  return (
    <Upload
      multiple={false}
      showUploadList={false}
      beforeUpload={(file) => {
        dispatch({
          type: 'SET_AMENDMENT_FILE_UPLOAD',
          amendmentFileUpload: file,
        });
        return false;
      }}
      data-testid={testId.amendmentFileUploadInput}
      accept="application/pdf, image/jpeg, image/jpg, image/png"
    >
      <Button icon={<UploadOutlined />}>Upload New Amendment</Button>
    </Upload>
  );
}

export default UploadContractAmendment;
